import {createSlice, createAsyncThunk} from '@reduxjs/toolkit'
import type {PayloadAction} from '@reduxjs/toolkit'
import adminService from './adminService'

// Get ListApplicationLetter
export const ListApplicationLetter = createAsyncThunk(
  'application-letter-list',
  async (params: {}, thunkAPI) => {
    try {
      return await adminService.applicationLetterList({params})
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

// EditApplicationLetter
export const EditApplicationLetter = createAsyncThunk(
  'application-letter-edit',
  async (id: string, thunkAPI) => {
    try {
      return await adminService.applicationLetterEdit(id)
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

// UpdateApplicationLetter
export const UpdateApplicationLetter = createAsyncThunk(
  'application-letter-update',
  async (data: {}, thunkAPI) => {
    try {
      return await adminService.applicationLetterUpdate({data})
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

// TestApplicationLetter
export const TestApplicationLetter = createAsyncThunk(
  'application-letter-test',
  async (id: string, thunkAPI) => {
    try {
      return await adminService.applicationLetterTest(id)
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

// Get news
export const ListNews = createAsyncThunk('news-list', async (params: {}, thunkAPI) => {
  try {
    return await adminService.newsList({params})
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

// Create news
export const createNews = createAsyncThunk('news-create', async (data: {}, thunkAPI) => {
  try {
    return await adminService.newsCreate({data})
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

// Get news id
export const editNews = createAsyncThunk('news-edit', async (id: string, thunkAPI) => {
  try {
    return await adminService.newsEdit(id)
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

// Delete news
export const deleteNews = createAsyncThunk('news-delete', async (id: string, thunkAPI) => {
  try {
    return await adminService.newsDelete(id)
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

// get News Type
export const GetTypes = createAsyncThunk('get-types', async (type: string, thunkAPI) => {
  try {
    return await adminService.getTypes(type)
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

// Toggle news
export const toggleNews = createAsyncThunk('news-toggle', async (id: string, thunkAPI) => {
  try {
    return await adminService.newsToggle(id)
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const viewNews = createAsyncThunk('news-details', async (id: string, thunkAPI) => {
  try {
    return await adminService.newsDetails(id)
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

// Get Types this is for lecturer to load only its content
export const GetNewsTypes = createAsyncThunk('get-news-types', async (type: string, thunkAPI) => {
  try {
    return await adminService.getNewsTypes(type)
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const ListArchivedNews = createAsyncThunk(
  'archived-news-list',
  async (params: {}, thunkAPI) => {
    try {
      return await adminService.archivedNewsList({params})
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const toggleArchiveNews = createAsyncThunk(
  'news-archive-toggle',
  async (id: string, thunkAPI) => {
    try {
      return await adminService.newsToggleArchive(id)
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const ListForm = createAsyncThunk('form-list', async (params: {}, thunkAPI) => {
  try {
    return await adminService.formList({params})
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const createForm = createAsyncThunk('form-create', async (data: {}, thunkAPI) => {
  try {
    return await adminService.formCreate({data})
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const editForm = createAsyncThunk('form-edit', async (id: string, thunkAPI) => {
  try {
    return await adminService.formEdit(id)
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const deleteForm = createAsyncThunk('form-delete', async (id: string, thunkAPI) => {
  try {
    return await adminService.formDelete(id)
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const StdAnnRep = createAsyncThunk('std-ann-rep', async (_, thunkAPI) => {
  try {
    return await adminService.stdAnnRep()
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const AlmAnnRep = createAsyncThunk('alm-ann-rep', async (_, thunkAPI) => {
  try {
    return await adminService.almAnnRep()
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const LecAnnRep = createAsyncThunk('lec-ann-rep', async (_, thunkAPI) => {
  try {
    return await adminService.lecAnnRep()
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

type AdminState = {
  record: any
  records: any
  errors: any
}

const initialState: AdminState = {
  records: {
    data: [],
  },
  record: {},
  errors: '',
}

export const adminSlice = createSlice({
  name: 'admin',
  initialState,
  reducers: {
    reset: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(ListApplicationLetter.fulfilled, (state, action: PayloadAction<any>) => {
        state.records = action.payload
      })
      .addCase(UpdateApplicationLetter.rejected, (state, action: PayloadAction<any>) => {
        state.errors = action.payload
      })
      .addCase(ListNews.fulfilled, (state, action: PayloadAction<any>) => {
        state.records = action.payload
      })
      .addCase(ListArchivedNews.fulfilled, (state, action: PayloadAction<any>) => {
        state.records = action.payload
      })
  },
})

export const {reset} = adminSlice.actions
export default adminSlice.reducer
